import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck, Star } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  return <section className="py-16 md:py-20 bg-section border-y border-line" aria-labelledby="reviews-title" data-id="element-257" data-mp="2hefaelxt750l">
      <div className="max-w-6xl mx-auto px-4" data-id="element-258" data-mp="2ras61pcwzsxz">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-259" data-mp="2rbl29we8z01v">
          <h2 id="reviews-title" className="text-3xl md:text-4xl font-display font-bold text-white mb-3" data-id="element-260" data-mp="2wa4tocbm141m">
            What boxing coaches are saying
          </h2>
          <p className="text-mist" data-id="element-261" data-mp="352gcpd4e9p7k">
            Real feedback from coaches using Boxing Coach Ready to save time, structure better
            sessions, and bring more variety into their classes.
          </p>
        </div>

        <ul className="no-scrollbar flex md:grid md:grid-cols-3 gap-5 overflow-x-auto md:overflow-visible snap-x snap-mandatory -mx-4 px-4 md:mx-0 md:px-0 pb-2" data-id="element-262" data-mp="3f1fdk9ix4gk0">
          {reviews.map((review, index) => <motion.li key={review.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="snap-center shrink-0 w-[85%] sm:w-[60%] md:w-auto bg-card border border-gold/30 rounded-2xl p-6 md:p-7 flex flex-col shadow-[0_18px_40px_-24px_rgba(0,0,0,0.8)]" data-id="element-263" data-mp="2rdgnfr31a3tc" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-264" data-mp="353sls7q7oysx">
                {[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" aria-hidden="true" data-id="element-265" data-mp="30b95h3053pkf" data-mpi={star} />)}
              </div>
              <blockquote className="text-white text-[15px] leading-relaxed mb-6 flex-grow" data-id="element-266" data-mp="3stmvwhj5c99h">
                &ldquo;{review.text}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 pt-5 border-t border-line" data-id="element-267" data-mp="3o1d5z1i17977">
                <div className="w-11 h-11 rounded-full bg-card-hi border border-gold/40 flex items-center justify-center text-gold font-display font-semibold shrink-0" aria-hidden="true" data-id="element-268" data-mp="1m6p8evw5xj4i">
                  {review.initials}
                </div>
                <div className="min-w-0" data-id="element-269" data-mp="1hdcw9l8o74sn">
                  <div className="font-bold text-white text-sm" data-id="element-270" data-mp="1hcb9ijiaktv3">{review.name}</div>
                  <div className="text-xs text-steel" data-id="element-271" data-mp="13gzf6d81t5ep">{review.role}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-[11px] font-medium text-gold whitespace-nowrap" data-id="element-272" data-mp="18fapep299hxg">
                  <BadgeCheck size={13} aria-hidden="true" data-id="element-273" data-mp="tj36ds2l2mjr" />
                  Verified Customer
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}